import PaginationInfo from './PaginationInfo.component';

export default PaginationInfo;
